<ng-container *transloco="let t; read: 'authentication'">
  <div
    role="button"
    tabindex="0"
    [attr.aria-label]="t('GOOGLE_SIGN_IN')"
    (click)="clickEvent.emit()"
    (keyup.enter)="clickEvent.emit()"
    (keyup.space)="clickEvent.emit()"
  >
    <img src="assets/logo_google.svg" alt="{{ t('GOOGLE_LOGO') }}" />
    <span>{{ t('GOOGLE_SIGN_IN') }}</span>
  </div>
</ng-container>
